import * as React from 'react';

import { Grid } from '@coursera/cds-core';

import Markdown from 'bundles/cms/components/Markdown';
import PersonalizedEmbeddedMsg from 'bundles/degree-description/components/modules/personalization/PersonalizedEmbeddedMsg';
import type { PersonalizedData } from 'bundles/degree-description/types';
import { getCtaActionXddp, getMessagesToDisplay } from 'bundles/degree-description/utils/personalizedMessageCriteria';
import type { Maybe } from 'bundles/xddp/__generated__/baseContentfulTypes';
import type { DegreePageContentFragment } from 'bundles/xddp/__generated__/contentfulTypes';
import Container from 'bundles/xddp/components/shared/Container';
import InfoSidebar from 'bundles/xddp/components/shared/InfoSidebar';
import type { AtAGlanceProps, UpsellsByDegreeSlug, UserAgentProps } from 'bundles/xddp/types';

import 'css!bundles/xddp/components/__styles__/homepage/ProgramOverview';

type Props = UserAgentProps & {
  marketingContent?: Maybe<string>;
  atAGlance?: Maybe<AtAGlanceProps>;
  listOfUpsellsLinkedtoThisDegree?: UpsellsByDegreeSlug;
  personalizedDdpData?: PersonalizedData;
  handlePersonalizedRequestInfoClick?: () => void;
  programName?: string | null;
  partnerName?: string | null;
  expressionOfInterestContainer: DegreePageContentFragment['expressionOfInterestContainer'];
  slug?: string | null;
};

const ProgramOverview = ({
  marketingContent,
  atAGlance,
  userAgent,
  listOfUpsellsLinkedtoThisDegree,
  personalizedDdpData,
  handlePersonalizedRequestInfoClick,
  programName,
  partnerName,
  expressionOfInterestContainer,
  slug,
}: Props) => {
  if (!marketingContent) {
    return null;
  }

  // Personalization
  const messagesToDisplay = getMessagesToDisplay(personalizedDdpData, slug, programName, partnerName);
  const embeddedAction = getCtaActionXddp(
    messagesToDisplay?.embeddedMessageToDisplay?.ctaActionType,
    expressionOfInterestContainer?.applyButtonUrl ?? expressionOfInterestContainer?.hostedApplicationUrl,
    handlePersonalizedRequestInfoClick
  );

  return (
    <div className="rc-ProgramOverview">
      <Container>
        <Grid container spacing={24}>
          <Grid item lg={9} md={8}>
            <Markdown className="programHighlights rc-Section" source={marketingContent} />
            {messagesToDisplay.embeddedMessageToDisplay && (
              <PersonalizedEmbeddedMsg
                personalizedMessage={messagesToDisplay.embeddedMessageToDisplay}
                ctaAction={embeddedAction}
                onXddp
              />
            )}
          </Grid>
          <InfoSidebar userAgent={userAgent} atAGlance={atAGlance} stackableItems={listOfUpsellsLinkedtoThisDegree} />
        </Grid>
      </Container>
    </div>
  );
};

export default ProgramOverview;
